<mat-chip
  [color]="data.color"
  highlighted
  [removable]="data.removable"
  [disabled]="data.disabled"
  (click)="onClick.emit()"
  (removed)="onDelete.emit()"
  [id]="data.id"
  [ngClass]="statusClass"
>
  {{ data.label }}

  <mat-icon class="close-icon" matChipRemove *ngIf="data.removable">
    cancel
  </mat-icon>
</mat-chip>
